import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-hd gfu-hd--h2" }
const _hoisted_2 = { class: "gfu-bt gfu-bt--b2" }
const _hoisted_3 = {
  class: "gfu-project-without-reward gfu-box _pa-0 gfu-box gfu-box--bulky _mt-3",
  "data-qa": "tip-section"
}
const _hoisted_4 = { class: "gfu-project-without-reward__action" }
const _hoisted_5 = { class: "gfu-btn__text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_unit_field = _resolveComponent("unit-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.Resources.ProjectHome.PledgeWithoutRewardHeader), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.PledgeWithoutRewardDescription), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_unit_field, {
        modelValue: $data.model.amount,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.amount) = $event)),
        "display-name": _ctx.Resources.ProjectHome.PledgeWithoutRewardAmountFieldName,
        "show-label": false,
        name: "model.amount",
        symbol: _ctx.currentCheckoutCurrency.shortName,
        placeholder: _ctx.Resources.ProjectHome.PledgeWithoutRewardAmountFieldPlaceholder,
        "text-align": "left",
        "validator-layout": "tooltip",
        class: "gfu-project-without-reward__currency-field _mt-0",
        onKeyup: _withKeys($options.submit, ["enter"]),
        "data-qa": "tip-section-field:TipAmount"
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "symbol", "placeholder", "onKeyup"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_tooltip, {
          enabled: $options.isButtonDisabled,
          text: $options.tooltipMessage,
          class: "gfu-1of1 gfu-project-without-reward__action",
          "data-qa": "add-tip-to-cart-button-tooltip"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_button, {
              enabled: !$options.isButtonDisabled,
              shape: "hard",
              display: "block",
              theme: $options.buttonTheme,
              class: "gfu-project-without-reward__button _tal",
              onClick: _withModifiers($options.submit, ["prevent"]),
              "data-qa": "tip-section-button:AddTip"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Resources.Product.RewardCardAddToPledgeButton), 1 /* TEXT */),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "_ga _ga--plus-bold-icon _fr" }, null, -1 /* CACHED */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["enabled", "theme", "onClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["enabled", "text"])
      ])
    ]),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}